/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Action } from '../../../../components/ActionsCard/ActionCard';
import { strings } from '../../../../intl/Strings';
import { logger } from '../../../../shared';
import { TrialActionId } from '../shared';

export const ExcelTryCopilotActionCard = (showSecondary: boolean = true): Action => ({
    id: TrialActionId.TryCopilotDialog,
    checked: false,
    primaryContent: strings.getString('trialconversionExcelTryCopilotDialogHeader'),
    secondaryContent: strings.getString('trialconversionExcelTryCopilotDialogContent'),
    showSecondaryContent: showSecondary,
    onClick: () => logger.logInfo('TrialConversionExcelCard', 'Try Copilot clicked'),
    retriggerable: true
});
